import React from "react";
import { ExternalLink } from "lucide-react";
import { addUtm } from "@/lib/utm";
import { trackEvent, reportBuyNavOutcome } from "@/lib/tracking";

// ONE OUTBOUND LINK, TAGGED AND COUNTED.
//
// Every link that leaves dharmaweave.com for a storefront goes through here, so
// two things are true of all of them and not just the ones someone remembered:
//
//   1. THE URL CARRIES A TAG. links.py refuses an untagged outbound link on the
//      caption side; this is the same refusal on the page side. `addUtm` is the
//      site's tagging brain — this component never composes a utm_* itself.
//
//   2. THE CLICK IS COUNTED BEFORE WE LOSE IT. Amazon, Etsy, the App Store and
//      Play all strip our parameters on arrival, so the event we fire at our own
//      door is the only honest record that the reader left. `sendBeacon` inside
//      trackEvent is what makes that survive the navigation.
//
// The `event` prop names which conversion this is, because the arms count
// different ones: `buy_click` for books and prints, `music_platform_click` for
// streaming, `app_store_click` for the app. A shared component that flattened
// them all into one name would make every arm's numerator the same number.

export default function TaggedOutbound({
  url,
  label,
  event = "buy_click",
  store,
  market,
  titleId,
  slug,
  campaign,
  className = "btn-pill",
  showIcon = true,
  children,
  // Books and prints navigate to a retailer that may swallow the hop inside a
  // Facebook in-app browser; streaming links do not need the 3s diagnostic.
  diagnoseNav = false,
  extra,
}) {
  if (!url) {
    return (
      <span className={`${className} opacity-60 cursor-default`} title="Coming soon">
        {children || label}
      </span>
    );
  }

  const stamped = addUtm(url, { campaign, content: store });

  return (
    <a
      href={stamped}
      target="_blank"
      rel="noopener noreferrer"
      className={className}
      data-track="tagged-out"
      data-store={store}
      onClick={() => {
        const props = {
          title_id: titleId || slug,
          slug,
          store,
          market,
          outbound_url: stamped,
          ...(extra || {}),
        };
        trackEvent(event, props);
        if (diagnoseNav) reportBuyNavOutcome(props);
      }}
    >
      {children || label}
      {showIcon && <ExternalLink size={13} />}
    </a>
  );
}
